import { Turbo } from "@hotwired/turbo-rails"
import { turboSubmit } from "../helpers/html_fetch"

// Custom actions

Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

Turbo.StreamActions.close_overlay = function () {
  const event = new CustomEvent("overlay:close")
  document.dispatchEvent(event)
}

// Fast load
//
// Dispatch a turbo:fast-load event when the DOM is ready and on all turbo:load
// events except the first one.

const dispatchFastLoad = () => {
  document.dispatchEvent(new Event("turbo:fast-load"))
}

document.addEventListener("DOMContentLoaded", dispatchFastLoad)

document.addEventListener("turbo:load", () => {
  document.addEventListener("turbo:load", dispatchFastLoad)
}, {once: true})

// Disable prefetch on slow connections

document.addEventListener("turbo:before-prefetch", (event) => {
  if (isSavingData() || hasSlowInternet()) {
    event.preventDefault()
  }
})

// Make formmmethod/formaction buttons CSRF-compatible
document.addEventListener("click", (event) => {
  const button = event.target.closest("button[formaction], button[formmethod], button[data-turbo-method]")
  if (!button) return

  const method = button.formMethod || button.dataset.turboMethod || "get"
  if (method === "get") return
  if (button.dataset.turbo === "false") return

  const action = button.hasAttribute("formaction") ? button.formAction : button.form?.action
  if (!action) return

  event.preventDefault()
  event.stopPropagation()

  turboSubmit(action, { method })
})


function isSavingData() {
  return navigator.connection?.saveData
}

function hasSlowInternet() {
  return navigator.connection?.effectiveType === "slow-2g" ||
         navigator.connection?.effectiveType === "2g"
}
